import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import { DataHelperConfiguration } from "@Scripts/Common/DataHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "CheckoutConfirm" })
export default class CheckoutConfirm extends Vue {
    public localizer: any = Localizer;
    public confirmData: any = null;
    public dataConfiguration: DataHelperConfiguration = { culture: (<any>window).App.userCulture };

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        await this.getData();
        this.setAnalytics();
    }

    public async getData() {
        this.confirmData = (await Axios.post(this.routes.StoreCheckout_GetConfirmData, { code: this.$route.query.orderCode })).data;
    }

    public setAnalytics() {
        var itemList = [];

        for (var storeOrderRow in this.confirmData.storeOrderRows) {
            itemList.push({
                item_id: this.confirmData.storeOrderRows[storeOrderRow].productCode,
                item_name: this.confirmData.storeOrderRows[storeOrderRow].productTitle,
                affiliation: "Beghelli",
                currency: "EUR",
                item_category: this.confirmData.storeOrderRows[storeOrderRow].productCategoryName,
                price: this.confirmData.storeOrderRows[storeOrderRow].unitPrice,
                quantity: this.confirmData.storeOrderRows[storeOrderRow].quantity
            });
        }

        GTagHelper.sendCustomEvent("purchase", {
            currency: "EUR",
            transaction_id: this.confirmData.storeOrder.code,
            value: this.confirmData.storeOrder.totalPrice,
            coupon: this.confirmData.storeOrder.couponCode,
            shipping: this.confirmData.storeOrder.shippingPrice,
            items: itemList
        });
    }

    public formatPrice(data: number) {
        return new Intl.NumberFormat('it-IT', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(data);
    }
};